import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { useToast } from './hooks/useToast';
import Sidebar from './components/Sidebar';
import Loading from './components/Loading';
import الرئيسية from './pages/الرئيسية';
import إدارةالحسابات from './pages/إدارةالحسابات';
import إدارةالطلبات from './pages/إدارةالطلبات';
import إدارةالمدفوعات from './pages/إدارةالمدفوعات';
import اختبارالتحميل from './pages/اختبارالتحميل';
import التصنيفات from './pages/التصنيفات';
import التقاريروالإحصائيات from './pages/التقاريروالإحصائيات';
import المحتوى from './pages/المحتوى';
import الإشعارات from './pages/الإشعارات';
import الإعدادات from './pages/الإعدادات';
import إعداداتطرقالدفع from './pages/إعداداتطرقالدفع';
import تسجيلالخروج from './pages/تسجيلالخروج';
import تسجيلالدخول from './pages/تسجيلالدخول';
import سياسةالخصوصية from './pages/سياسةالخصوصية';
import شروطالاستخدام from './pages/شروطالاستخدام';
import حولالتطبيق from './pages/حولالتطبيق';

const AppContent = () => {
  const { isAuthenticated, loading, logout } = useAuth();
  const { ToastContainer } = useToast();
  const [activePage, setActivePage] = useState('الرئيسية');
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  useEffect(() => {
    if (!isAuthenticated && !loading) {
      // Redirect to login if not authenticated
      // This would be handled by a login page in a real app
    }
  }, [isAuthenticated, loading]);

  const handleLogoutClick = () => {
    setActivePage('تسجيل الخروج');
  };

  const handlePageChange = (page) => {
    if (page === 'تسجيل خروج') {
      handleLogoutClick();
    } else {
      setActivePage(page);
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const renderPage = () => {
    switch (activePage) {
      case 'الرئيسية':
        return <الرئيسية toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />;
      case 'إدارة الحسابات':
        return <إدارةالحسابات />;
      case 'إدارة الطلبات':
        return <إدارةالطلبات />;
      case 'إدارة المدفوعات':
        return <إدارةالمدفوعات />;
      case 'إعدادات طرق الدفع':
        return <إعداداتطرقالدفع />;
      case 'اختبار التحميل':
        return <اختبارالتحميل />;
      case 'التصنيفات':
        return <التصنيفات />;
      case 'التقارير والإحصائيات':
        return <التقاريروالإحصائيات />;
      case 'المحتوى':
        return <المحتوى />;
      case 'الإشعارات':
        return <الإشعارات />;
      case 'الإعدادات':
      case 'الإعدادات العامة':
        return <الإعدادات />;
      case 'سياسة الخصوصية':
        return <سياسةالخصوصية />;
      case 'شروط الاستخدام':
        return <شروطالاستخدام />;
      case 'حول التطبيق':
        return <حولالتطبيق />;
      case 'تسجيل الخروج':
        return <تسجيلالخروج />;
      default:
        return <الرئيسية toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />;
    }
  };

  if (loading) {
    return <Loading />;
  }

  if (!isAuthenticated) {
    return <تسجيلالدخول />;
  }

  // Show logout page as full screen
  if (activePage === 'تسجيل الخروج') {
    return <تسجيلالخروج />;
  }

  return (
    <>
      <div style={{
        width: '100vw',
        height: '100vh',
        backgroundColor: '#2B2F3F',
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
        overflow: 'hidden',
        boxSizing: 'border-box',
        direction: 'rtl'
      }}>
        <Sidebar
          activePage={activePage}
          setActivePage={handlePageChange}
          isOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />
        <div style={{
          flex: 1,
          width: '100%',
          height: '100vh',
          overflow: 'hidden',
          transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
          display: 'flex',
          flexDirection: 'column'
        }}>
          {renderPage()}
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
